import React from 'react';
import { useSelector } from 'react-redux';
import { selectScreenSize } from 'store/slice/screen';

type ScreenSizeProps = React.PropsWithChildren<{
    condition?: boolean | (() => boolean);
    showOnDesktop: boolean;
}>;

const ScreenSizeConditional: React.FC<ScreenSizeProps> = React.memo(({ children, condition, showOnDesktop }) => {
    const screenSize = useSelector(selectScreenSize);

    if (condition) {
        if (typeof condition === 'boolean' && !condition) return null;
        if (typeof condition === 'function' && !condition()) return null;
    }
    if (screenSize.desktop !== showOnDesktop) return null;

    return <>{children}</>;
});
ScreenSizeConditional.displayName = 'ScreenSizeConditional';

export const ScreenSizeDesktop: React.FC<React.PropsWithChildren<{ condition?: boolean | (() => boolean) }>> = (props) => <ScreenSizeConditional {...props} showOnDesktop={true} />;
ScreenSizeDesktop.displayName = 'ScreenSizeDesktop';

export const ScreenSizeNonDesktop: React.FC<React.PropsWithChildren<{ condition?: boolean | (() => boolean) }>> = (props) => (
    <ScreenSizeConditional {...props} showOnDesktop={false} />
);
ScreenSizeNonDesktop.displayName = 'ScreenSizeNonDesktop';

export default {
    Desktop: ScreenSizeDesktop,
    NonDesktop: ScreenSizeNonDesktop,
};
